<template>


  <div class="">




        <!-- top menu -->
      <nav v-if="headFoot" id="top-menu" class="navbar navbar-expand-xxl navbar-light py-1 py-xxl-1 sticky-top">
        <div class="container">
          <a class="navbar-brand" href="https://nau.pl">
         <img class="logo img-fluid" src="static/logo.svg" alt="" >
          </a>
          <div>

                <button class="navbar-toggler" v-on:click='isOpen = !isOpen'>
                  <span class="navbar-toggler-icon"></span>
                </button>
          </div>

          <div class="navbar-collapse" v-show="isOpen">


              <ul id="top-menu" class="d-none d-xxl-flex navbar-nav mx-auto mt-3 mt-xl-0 mb-3 mb-xl-0 position-absolute top-50 start-50 translate-middle">
                <li id="menu-item-223" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-223 nav-item me-4"><a href="https://nau.pl/produkty-ubezpieczeniowe/" class="nav-link">Produkty Ubezpieczeniowe</a></li>
                <li id="menu-item-41" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-41 nav-item me-4"><a href="https://nau.pl/ubezpieczenia-grupowe/" class="nav-link">Ubezpieczenia grupowe</a></li>
                <li id="menu-item-36" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/likwidacja-szkod/" class="nav-link">Likwidacja szkód</a></li>
                <li id="menu-item-36" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/klub-nau/" class="nav-link">Klub NAU</a></li>
                <li id="menu-item-36" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/strefa-multiagenta/" class="nav-link">Strefa Multiagenta</a></li>
                <li id="menu-item-36" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/kontakt/" class="nav-link">Kontakt</a></li>
              </ul>


            <ul id="top-menu" class="navbar-nav mt-3 mt-xl-0 mb-3 mb-xl-0 d-xxl-none">
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-223 nav-item me-4"><a href="https://nau.pl/produkty-ubezpieczeniowe/" class="nav-link">Produkty Ubezpieczeniowe</a></li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-41 nav-item me-4"><a href="https://nau.pl/ubezpieczenia-grupowe/" class="nav-link">Ubezpieczenia grupowe</a></li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/likwidacja-szkod/" class="nav-link">Likwidacja szkód</a></li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/klub-nau/" class="nav-link">Klub NAU</a></li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/strefa-multiagenta/" class="nav-link">Strefa Multiagenta</a></li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-36 nav-item me-4"><a href="https://nau.pl/kontakt/" class="nav-link">Kontakt</a></li>
            </ul>



            <div class="ms-xl-auto">
              <a v-if="loggedIn && !isClientV"  class="d-none d-xxl-inline-block btn btn-outline-primary me-2" @click="gotoclient" >Strefa klienta </a>
              <a v-if="!loggedIn" class="btn btn-outline-primary btn-lg me-2" data-bs-toggle="modal" data-bs-target="#loginDialog" id="login-button"  v-on:click='isOpen = !isOpen'>Zaloguj się </a>
              <a v-if="loggedIn" class="login-button btn btn-outline-primary btn-lg me-2" @click="doLogout" > Wyloguj </a>
            </div>

          </div>
        </div>
      </nav>















    <LPopup/>
    <ForgotPassword/>


    <loading-screen :is-loading="isLoading"></loading-screen>



    <router-view :form="form"></router-view>





<footer v-if="headFoot" class="">
      <b-container fluid="m" class="wholeFooter" id="wholeFooter">
        <b-row class="firstRowFooter" >
          <b-col lg="2" class="picCol">
            <ul>
              <li>
                <img class="logo img-fluid" src="static/logo.svg" alt="" style="padding:0">
              </li>
              <li class="liUnderPic">
                Nauczycielska Agencja <br> Ubezpieczeniowa SA
              </li>
              <li class="liUnderPic2">
                Infolinia <br> <strong> 22 696 72 70</strong>
              </li>
            </ul>
          </b-col>
          <b-col lg="2" class="firstRowColumn">
            <ul>
              <li>
                <a href=" https://nau.pl/produkty-ubezpieczeniowe/">Produkty ubezpieczeniowe</a>
              </li>
              <li>
                <a href="https://nau.pl/likwidacja-szkod/">Likwidacja szkód</a>
              </li>
              <li>
                <a href="https://nau.pl/ubezpieczenia-grupowe/">Ubezpieczenia grupowe</a>
              </li>
            </ul>
          </b-col>
          <b-col lg="2" class="firstRowColumn">
            <ul >
              <li>
                <a href="https://nau.pl/klub-nau/">Klub NAU</a>
              </li>
              <li>
                <a href="https://nau.pl/strefa-multiagenta/">Strefa Mulitagenta</a>
              </li>
              <li>
                <a href="https://nau.pl/aktualnosci/">Aktualności</a>
              </li>
              <li>
                <a href="https://nau.pl/centrum-prasowe/">Centrum prasowe</a>
              </li>
            </ul>
          </b-col>
          <b-col lg="2" class="firstRowColumn">
            <ul >
              <li>
                <a href="https://nau.pl/o-firmie/">O firmie</a>
              </li>
              <li>
                <a href="https://nau.pl/kariera/">Kariera</a>
              </li>
              <li>
                <a href="https://nau.pl/dla-akcjonariuszy/">Dla akcjonariuszy</a>
              </li>
            </ul>
          </b-col>
          <b-col lg="2" class="firstRowColumn">
            <ul >
              <li>
                <p>Social media</p>
              </li>
              <li>
                <i style="color: white" class="fab fa-facebook-f"></i>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="secondRowFooter">
          <b-col class="secondRowFooterColumn1" cols="8" lg="4" offset-lg="3">
            <p><a href="https://nau.pl/kontakt/">Kontakt</a> <a class="textwidget-item" href="https://nau.pl/pelnomocnictwa/">Pełnomocnictwa</a><br>
              <a target="_blank" href="http://naukids.pl" rel="noopener">NAU Kids</a> <a class="textwidget-item" target="_blank">NAU Mobile</a></p>
          </b-col >
          <b-col lg="5" cols="4" class="secondRowFooterColumn2">
            <ul>
              <li>
                <p><a href="https://nau.pl/polityka-prywatnosci/">Polityka Prywatności</a></p>
              </li>
            </ul>
          </b-col>
        </b-row>
    </b-container>
    </footer>







  </div>
</template>

<script>


  import Loader from "./components/Loader";

  import LPopup from "./components/LoginPopup";

  import ForgotPassword from './components/ForgotPasssword';

export default {
  name: 'NauPage',

    components: {
      'loading-screen': Loader,
      LPopup,
      ForgotPassword
    },


  computed: {
//console.log('is client')
//console.log(this.$router.currentRoute.path)
  },


  data() {
    return {

      // persystentny, globalny objekt wniosku przekazywany do kazdego widoku
      // przez <router-view :form="form">
      form: {},

      isLoading: false,
      isClientV: false,
      loggedIn: false,
      isOpen: false,

      // registered by affiliate - otp login
      isRegisterLink: false,

      // user-friendly komunikat bledu przetwarzania wniosku (strona /pending)
      pendingMessage: '',

      headFoot: true

    }
  },


  watch:{
    $route (to){

      this.isClientV = to.path === '/client';

    }
  },



  methods: {

    doLogout(notoast=false){
      this.isOpen = !this.isOpen;
      // remove user from local storage to log user out
      localStorage.removeItem('user');

      this.loggedIn = false;


      this.$route.path != '/'
        && this.$router.push({path: '/'});


      // reset persystentnego objektu wniosku
      this.form = new Object();

      // wyczysc ewentualny komunikat bledu
      this.pendingMessage = '';


      !notoast
        && this.toast('Wylogowano!');
    },




    gotoclient() {

        this.$router.push({path: '/client'}).then( success => {return success});
    },


    gotologin() {

        this.$router.push({path: '/login'});
    },



    gotothanku() {

        this.$router.push({path: '/thankyou'});
    },



    gotokontox() {


        this.$router.push({path: 'kontox'});

    },




    foobar() {


        console.log('this is is roots 1 page')
    }

  },


  created() {

    let dt = localStorage.getItem('user');

      this.listen('logged_in', (data) => {
          this.loggedIn = data;
      });
      this.listen('next_step_fail', () => {
          /*console.log("elo");*/
          this.echo('ForgotPasswordModal',"stepFail");
      });

    this.listen('logged_in', (data) => {
      this.loggedIn = data;
    });



    this.get( '/session' )
    .then(response => {

      if (!!response.data) {
        let ok = !(response.data.IS_ERROR | 0);


        if ( ok && dt ) {

          this.loggedIn = JSON.parse(dt);
        }

      }
    })
    .catch(error => {

      !!dt && this.doLogout(true);

      // Error
      if (error.response) {
         //console.log(error.response);
      }
    });



    if (this.$route.path == '/pdf') {

      this.headFoot = false;
    }


  },


  mounted() {



    let uri = window.location.href.split('?');



     if (uri.length > 1 && /login/.test(uri[1]) ) {

        this.echo('login_dialog');
     }

   let uriForgotPassword = window.location.href.split('?');


    if (uri.length > 1 && /code=/.test(uriForgotPassword[1]) ) {

        let url_array = window.location.href.split('\/').join().split('?').join().split('code=')
        let tmp_token_before_regex=url_array[1]



        var tmp_token = tmp_token_before_regex.replace(/[#,]/g, "");
        /*console.log(tmp_token)*/
        this.echo('ForgotPasswordModal',tmp_token);
    }



    // wyciaga i czysci pojedynczy parametr z URL
    let uriToken = pName => {

      let url_array = window.location.href.split('\/').join().split('?').join().split( pName + '='),
          tmp_token_before_regex = url_array[1],
          token = tmp_token_before_regex.split('#');

      // clean param
      let params = new URLSearchParams(location.search);
      params.delete( pName );
      history.replaceState(null, '', '?' + params + location.hash);

      return token[0];
    };



    // register by link - prefill persystentnego objektu form danymi z OTP
    if (uri.length > 1 && /register=/.test(uri[1])) {


      let regToken = uriToken('register');


      if (!regToken) {

        this.log( '- OTP REGISTER - no token - skip' );
      }
      else {

        this.log( '- OTP REGISTER - ' + regToken );


        this.isLoading = true;

        this.get('/application/otp/' + regToken )

          .then(response => {

            this.isLoading = false;


            let f = this.getConf('fields_otp_mapping');

            if (!!response.data && !!f) {


              this.isRegisterLink = true;


              let ob = response.data,
                  has;


              // set little delay to give some render time.
              setTimeout( () => {

                // fill up form
                Object.keys(f).map( k => {


                    has = ob.hasOwnProperty( f[k] ) ? ob[ f[k] ] : f[k];


                    //cascade fields and parse

                    // cut the whitespaces / enters etc.. from portal app
                    if (/client_name|client_surname|client_email/.test(k)) {

                      this.$set(this.form, k, String(has).trim());
                    }
                    else if (/client_employment_income/.test(k)){

                      this.$set(this.form, k, parseInt(has | 0));
                    }
                    else if (/client_address[1-2]_building/.test(k)){

                      // limited by validation to 10 chars
                      if (String(has).length > 10) {

                        this.$set(this.form, k, String(has).substr(0,10));
                      }
                      else {

                        this.$set(this.form, k, has);
                      }
                    }
                    else if (/client_employment_type/.test(k)){

                      // test if valid employment value provided
                      if ([0,2,3,4,5,6,8,9,11,12,14,7,13,1].indexOf( (has | 0) ) > -1 ) {

                        this.$set(this.form, k, parseInt(has));
                      }
                      else {

                        // default employment type - 4 equals other
                        this.$set(this.form, k, 4);
                      }
                    }

                    // default
                    else {

                      this.$set(this.form, k, has);
                    }

                  });

              }, 500);

            }

          })
          .catch(error => {

            this.isLoading = false;

            this.log( '- OTP REGISTER - get otp data fail.' );
          });

      }

    }



    /*setTimeout(() => {
      this.isLoading = false
    }, 5000)*/
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  #top-menu > div.container {

    padding-top: 0;
    padding-bottom: 0;
  }
  @media (min-width: 1px) {
    .wholeFooter li{
      justify-content: center;
      text-align: center;
      white-space: normal;
    }
    .wholeFooter .secondRowFooter::before {
      content: "";
      background: #fff;
      position: relative;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 95%;
      margin-left: 2.5%;
    }
    .secondRowFooterColumn1 a{
      padding: 5px 5px;
      display: block;
    }
    .firstRowFooter li{
      padding: 5px 10px;
      display: block;
    }
  }
  @media (min-width: 400px) {
    .secondRowFooterColumn1 p{
      display: grid;
      white-space: pre-wrap;
    }
    .secondRowFooter p {
      display:flex;
    }
    .wholeFooter li{
      justify-content: center;
      text-align: center;
    }
    .firstRowFooter li{
      text-align: center;
      margin: 7px 0px;
    }
    .firstRowFooter .liUnderPic{
      margin: 15px 0px 20px;
    }
    .firstRowFooter .liUnderPic{
      margin: 15px 0px 20px;
      padding: 0;
    }
    .firstRowFooter .liUnderPic2{
      margin-bottom: 1.5em;
    }
    .secondRowFooterColumn2{
      padding-right: 15px;
      display: inline-block;
      text-align: left;

    }
    .secondRowFooterColumn1 {
      justify-content: center;
      display: flex;
    }

    .wholeFooter .secondRowFooter::before {
      content: "";
      background: #fff;
      position: relative;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 95%;
      margin-left: 2.5%;
    }
  }
  @media(min-width: 992px){
    .secondRowFooterColumn1{
      justify-content: left;
    }
    .wholeFooter .secondRowFooter::before {
      content: "";
      background: #fff;
      position: relative;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 59vw;
      margin-left: 25.5%;
    }
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media(min-width: 1040px){
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media(min-width: 1070px){
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media(min-width: 1200px){
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media (min-width: 1400px) {

    .firstRowColumn li{
      white-space: nowrap;
    }
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }

  .wholeFooter{
    font: normal normal normal 16px/25px "Poppins";
    padding-top: 3rem;
    padding-bottom: 3rem;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #626d80;

  }
  #wholeFooter li a { margin: 0px; display: block; width: 100%; height: 100%; }
  .wholeFooter li{
    list-style: none;
    color: white;
    font-size: 16px;
    width: 100%;
  }
  .wholeFooter a{
    color: white;
    text-decoration: none;
  }
  .firstRowFooter{
    justify-content: center;

  }
  .picCol{
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0;
    padding-left: 0;
  }
  .firstRowColumn{
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 15px;
    padding-left: 15px;
  }
  .firstRowFooter ul{
    padding: 0;

  }


  .picCol li{
    margin: 0;

  }
  .picCol image{
    width: 117px;
    height: 50px;
  }

  .liUnderPic{
    padding-top: 1.5rem;
    padding-bottom: .5rem;
  }
  .liUnderPic2{
    margin-bottom: 1.5em;
  }
  .secondRowFooter{
    padding-top: 1.5rem!important;
  }
  .secondRowFooter a{
    margin-right: 15px;
    text-decoration: none;
    color: white;
  }
  .secondRowFooterColumn1 a{
    white-space: nowrap;
  }


  .secondRowFooterColumn2 a {
    text-align: right;
    padding-right: 14vw;
  }
  b-row{
    display: inline-block;
  }
  b-col{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/NauPage.vue